import { render } from "./Credit.vue?vue&type=template&id=a16684b4&scoped=true"
import script from "./Credit.vue?vue&type=script&lang=js"
export * from "./Credit.vue?vue&type=script&lang=js"

import "./Credit.vue?vue&type=style&index=0&id=a16684b4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a16684b4"

export default script